import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PermissoesAcessoService } from '../permissoes-acesso.service';
import { Paginacao } from '../../comum/modelos/paginacao';
import { Evento } from '../../comum/eventos/evento';
import { ComumService } from '../../comum/comum.service';
import { GrupoAcesso } from '../../comum/modelos/grupo-acesso';
import { ConfirmationService } from 'primeng/primeng';
import { CookieService } from 'angular2-cookie/core';
import { AuthService } from '../../auth/auth.service';

@Component({
  selector: 'app-listar-grupo-acesso',
  templateUrl: './listar-grupo-acesso.component.html',
  styleUrls: ['./listar-grupo-acesso.component.css']
})
export class ListarGrupoAcessoComponent implements OnInit {

  filtroPesquisaNomeGrupoAcesso: string;
  gruposAcesso: GrupoAcesso[];
  statusCode: number;
  public paginacao: Paginacao;
  public evento: Evento;

  public loading = false;

  constructor(
    private _permissoesAcessoService: PermissoesAcessoService,
    private _comumService: ComumService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private _cookieService: CookieService,
    private _authService: AuthService) {
    this.gruposAcesso = new Array<GrupoAcesso>();
    this.paginacao = new Paginacao();
    this.evento = this._comumService.evento;
    this.loading = false;
    if (this.evento !== undefined) {
      setTimeout(() => { this._comumService.cleanEvent(); }, 2000);
    }
  }

  ngOnInit() {
    this.paginacao.itens = 5;
    this.paginacao.page = 1;
    this.loading = true;
    this._permissoesAcessoService.obterGruposAcessoHttp(parseInt(this._cookieService.get('idCliente'), 10))
      .subscribe((gruposAcesso) => {
        this.gruposAcesso = gruposAcesso;
        this.loading = false;
      });
  }

  removerGrupoAcesso(permissaoAcesso: GrupoAcesso): void {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja excluir o grupo de acesso',
      accept: () => {
        this.loading = true;
        this._permissoesAcessoService.apagarGrupoAcessoHttp(permissaoAcesso.idGrupoAcesso)
          .subscribe(response => {
            this.loading = false;
            this.statusCode = response.status;
            this._comumService.evento.deletar = true;
            this.router.navigate(['listar-grupo-acesso']);
            setTimeout(() => { this.evento.limparEventos(); }, 3000);
          }, errorCode => {
            this.statusCode = errorCode;
            this.loading = false;
          });
      },
      reject: () => {
      }
    });
  }

  pesquisarPorFiltro(filtro: any): void {
    this.filtroPesquisaNomeGrupoAcesso = filtro.value;
  }

  limparPesquisaPorFiltro(filtro: any): void {
    filtro.value = '';
    this.pesquisarPorFiltro(filtro);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/permissoes-acesso/listar-grupo-acesso/listar-grupo-acesso.component.ts